import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button, Line, MyTextInput, Spacing, Typography } from 'components/src';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { createUseStyles, usePutUserUpdateUserProfile } from 'core/src';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;

interface Props {
  bioEdit: Boolean;
  nameAndFamily: any;
  userName: any;
  _bio?: any;
  loadData?: any;
}

const ProfileAccount = memo<Props>(
  ({ bioEdit, nameAndFamily, userName, _bio, loadData }) => {
    const { i18n } = useTranslation();
    const { styles, colors } = useStyles();
    const [editable, setEditable] = useState(false);
    const [bio, setBio] = useState<string>('');
    const { mutate, isSuccess } = usePutUserUpdateUserProfile();

    useEffect(() => {
      isSuccess && loadData;
    }, [isSuccess]);
    const userUpdate = useCallback(() => {
      mutate({
        requestBody: {
          bio,
          email: '',
        },
      });
    }, [bio]);

    const handleBio = () => {
      setEditable(!editable);
    };

    const handleChangeText = (newText: any) => {
      setBio(newText);
    };

    return (
      <>
        <Typography text={i18n.t('account')} classes={styles.headerText} />

        <View style={styles.box}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <View>
              <Typography
                text={nameAndFamily || null}
                weight={'bold'}
                color={colors.primaryColor}
              />
              <Spacing horizontal={2} />
            </View>
          </View>
          <Spacing vertical={4} />
          <View>
            <Typography
              text={i18n.t('fullName')}
              color={colors.secondryColor}
            />
          </View>

          <Spacing vertical={4} />
          <Line />
          <Spacing vertical={4} />

          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Spacing horizontal={2} />
            <Typography
              text={userName || null}
              weight={'bold'}
              color={colors.primaryColor}
            />
          </View>
          <Spacing vertical={4} />
          <View>
            <Typography
              text={i18n.t('userName')}
              color={colors.secondryColor}
            />
          </View>
          <Spacing vertical={4} />

          <Line />

          <>
            <Spacing vertical={4} />
            {editable && bioEdit ? (
              <>
                <MyTextInput
                  mxLength={25}
                  multiline={true}
                  classes={styles.input}
                  placeholder={isSuccess ? bio : _bio}
                  change={handleChangeText}
                  focus={true}
                  blur={() => {
                    setEditable(false);
                    userUpdate();
                  }}
                />
                <Button>
                  <MaterialIconsX
                    name="check"
                    size={21}
                    color={colors.primaryColor}
                  />
                </Button>
              </>
            ) : (
              <>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Typography
                      text={isSuccess ? bio : _bio}
                      weight={'bold'}
                      color={colors.primaryColor}
                      classes={{ flexShrink: 1 }}
                    />
                  </View>
                </View>
                <Spacing vertical={4} />
                <Typography text={i18n.t('bio')} color={colors.secondryColor} />

                {bioEdit && (
                  <Button onClick={handleBio}>
                    <MaterialIconsX
                      name="edit"
                      size={21}
                      color={colors.primaryColor}
                    />
                  </Button>
                )}
              </>
            )}
          </>

          {/* {bioEdit ? (
            <Button onClick={handleBio}>
              {editable ? (
                <MyTextInput
                  multiline={true}
                  classes={styles.input}
                  value={bio}
                  change={handleChangeText}
                  focus={true}
                  blur={() => {
                    setEditable(false);
                    userUpdate();
                  }}
                />
              ) : (
                <>
                  <Spacing vertical={4} />
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Typography
                        text={isSuccess ? bio : _bio}
                        weight={'bold'}
                        color={colors.primaryColor}
                        classes={{ flexShrink: 1 }}
                      />
                    </View>
                  </View>
                  <Spacing vertical={4} />
                  <Typography
                    text={i18n.t('bio')}
                    color={colors.secondryColor}
                  />
                </>
              )}
            </Button>
          ) : (
            <>
              <Spacing vertical={4} />
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <View style={{ flex: 1 }}>
                  <Typography
                    text={_bio || null}
                    weight={'bold'}
                    color={colors.primaryColor}
                    classes={{ flexShrink: 1 }}
                  />
                </View>
              </View>
              <Spacing vertical={4} />
              <Typography text={i18n.t('bio')} color={colors.secondryColor} />
            </>
          )} */}
        </View>
      </>
    );
  },
);
const useStyles = createUseStyles(({ theme, colors }) => ({
  box: {
    padding: 20,
    margin: 10,
    borderRadius: 20,
    backgroundColor: colors.drawerHeaderBox,
  },
  input: {
    padding: 5,
    width: '100%',
    zIndex: 3,
    maxHeight: 40,
    backgroundColor: colors.bioInput,
  },
  headerText: {
    paddingLeft: 15,
    paddingRight: 15,
    color: colors.color01,
    fontWeight: 'bold',
  },
}));

export { ProfileAccount };
